// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conn-dialog-s3-source {
  display: flex;
  flex-direction: column;
  height: 340px;
}
.conn-dialog-s3-source__list-container {
  overflow: auto;
}
.conn-dialog-s3-source__list-header, .conn-dialog-s3-source__list-row {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 12px;
  height: 42px;
  padding: 0 8px;
  border-bottom: 1px solid var(--g-color-line-generic);
}
.conn-dialog-s3-source__list-header {
  font-weight: 500;
}
.conn-dialog-s3-source__list-header-clickable {
  display: flex;
  gap: 12px;
  cursor: pointer;
}
.conn-dialog-s3-source__list-row {
  width: 100%;
  cursor: pointer;
}
.conn-dialog-s3-source__list-row_disabled {
  background-color: var(--g-color-base-generic-accent-disabled);
  cursor: default;
}
.conn-dialog-s3-source__list-row_selected {
  background-color: var(--g-color-base-selection);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/connections/components/dialogs/S3Source/DialogS3Source.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;AACI;EACI,cAAA;AACR;AAEI;EAEI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,oDAAA;AADR;AAII;EACI,gBAAA;AAFR;AAKI;EACI,aAAA;EACA,SAAA;EACA,eAAA;AAHR;AAMI;EACI,WAAA;EACA,eAAA;AAJR;AAMQ;EACI,6DAAA;EACA,eAAA;AAJZ;AAOQ;EACI,+CAAA;AALZ","sourcesContent":[".conn-dialog-s3-source {\n  display: flex;\n  flex-direction: column;\n  height: 340px;\n}\n.conn-dialog-s3-source__list-container {\n  overflow: auto;\n}\n.conn-dialog-s3-source__list-header, .conn-dialog-s3-source__list-row {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 12px;\n  height: 42px;\n  padding: 0 8px;\n  border-bottom: 1px solid var(--g-color-line-generic);\n}\n.conn-dialog-s3-source__list-header {\n  font-weight: 500;\n}\n.conn-dialog-s3-source__list-header-clickable {\n  display: flex;\n  gap: 12px;\n  cursor: pointer;\n}\n.conn-dialog-s3-source__list-row {\n  width: 100%;\n  cursor: pointer;\n}\n.conn-dialog-s3-source__list-row_disabled {\n  background-color: var(--g-color-base-generic-accent-disabled);\n  cursor: default;\n}\n.conn-dialog-s3-source__list-row_selected {\n  background-color: var(--g-color-base-selection);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
